<template>
  <div class="custom-najbox-container">
    <naj-box
      :title="local.complaints.complaintDetails.caseInfo.searchInCases"
      header-icon="mdi-format-list-bulleted-square"
      header-class="sub-header"
      disable-collapsing
      has-footer
    >
      <naj-dynamic-form
        :form-model="searchQuery"
        :form-fields="filters"
      ></naj-dynamic-form>

      <template v-slot:footer>
        <span />
        <div>
          <naj-button
            color="primary"
            icon="mdi-magnify"
            @click="searchCases"
          >
            {{ local.common.search }}
          </naj-button>
        </div>
      </template>
    </naj-box>

    <naj-item-table
      :data-items="caseList || []"
      :headers="headers"
      :loading="loading"
      :pagination="pagination"
      :items-per-page="pagination.pageSize"
      :server-items-length="pagination.totalCount"
      :enable-expand="false"
      :hide-default-no-data="true"
      @update:page="onPageChange"
    >
      <template
        slot="selectAction"
        slot-scope="{item, index }"
      >
        <div class="info-item-details-title info-item-checkbox">
          <naj-input
            :key="'caseCheckBox'"
            :type-id="formFieldType.radioButton"
            :value.sync="selectedCase"
            :items="[{...item}]"
            item-value="id"
            @change="onSelectionChange(item,index)"
          ></naj-input>
        </div>
        <div class="info-item-details-value" />
      </template>
      <template slot="noData">
        <v-col class="text-center">
          <naj-archive-icon></naj-archive-icon>

          <p class="no-data-text">
            {{ local.common.noData }}
          </p>
        </v-col>
      </template>
    </naj-item-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapComplaintsActions } = createNamespacedHelpers('ComplaintsModule');
export default {
  name: 'CaseList',
  components: {},
  props: {
    complaintObj: {
      type: Object,
      default: () => ({}),
    },
    complaintCategories: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      originalCaseList: [],
      caseList: [],
      loading: false,
      selectedCase: null,
      searchQuery: {
        code: null,
        typeId: null,
        courtId: null,
        relationId: null,
        creationDate: null,
      },
      pagination: {
        pageSize: 5,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      headers: [
        {
          value: 'selectAction',
          text: null,
          isCustomTemplate: true,
        },
        {
          value: 'caseNumber',
          text: this.local.complaints.complaintDetails.caseInfo.caseCode,
        },
        {
          value: 'caseDateHijri',
          text: this.local.complaints.complaintDetails.caseInfo.date,
        },
        {
          value: 'caseStatusDesc',
          text: this.local.complaints.complaintDetails.caseInfo.status,
        },
        {
          value: 'roleInCaseDesc',
          text: this.local.complaints.complaintDetails.caseInfo.relation,
        },
        {
          value: 'caseTypeDesc',
          text: this.local.complaints.complaintDetails.caseInfo.type,
        },
        {
          value: 'courtName',
          text: this.local.complaints.complaintDetails.caseInfo.court,
        },
      ],
    };
  },
  computed: {
    hasFilter() {
      return this.searchQuery.code ||
        this.searchQuery.typeId ||
        this.searchQuery.courtId ||
        this.searchQuery.relationId ||
        this.searchQuery.creationDate;
    },
    filters() {
      this.loadFilterData();
      return [
        this.mapFilterItem('code', 'caseCode', 'text', 6),
        this.mapFilterItem('typeId', 'type', 'selectbox', 6, this.caseTypes),
        this.mapFilterItem('courtId', 'court', 'selectbox', 6, this.courts),
        this.mapFilterItem('relationId', 'relation', 'selectbox', 6, this.relations),
        this.mapFilterItem('creationDate', 'date', 'date', 12),
      ];
    },
    computedSearchQuery() {
      return Object.assign({}, this.searchQuery);
    },
  },
  watch: {
    selectedCase: {
      handler(newVal, oldValue) {
        if (oldValue && !newVal)
          this.selectedCase = oldValue;
      },
      deep: true,
    },
  },
  created() {
  },
  mounted() {
    this.loadOriginalCaseList();
  },
  methods: {
    ...mapComplaintsActions([
      'getCaseLists',
    ]),
    loadOriginalCaseList() {
      this.loading = true;
      this.getCaseLists()
        .then(({ data }) => {
          for (let i = 1; i <= data.length; i++) {
            this.$set(data[i - 1], 'id', i);
          }
          this.originalCaseList = data;
        })
        .finally(() => {
          this.loading = false;
          this.loadFilterData();
          this.loadData(0);
        });
    },
    mapFilterItem(name, key, typeId, columnSize, items = []) {
      return {
        name: name,
        label: this.local.complaints.complaintDetails.caseInfo[key],
        typeId: this.formFieldType[typeId],
        columnSize: columnSize,
        dataSource: items,
      };
    },
    loadData(pageIndex) {
      var dataList = this.originalCaseList;
      if (this.hasFilter)
        dataList = this.filterData();
      this.loadPagination(dataList, pageIndex);

    },
    loadPagination(list, index) {
      this.pagination.totalCount = list.length;
      this.pagination.totalPages = Math.ceil(list.length / this.pagination.pageSize);
      this.pagination.hasNextPage = this.pagination.totalPages != (index + 1);
      this.pagination.hasPreviousPage = this.pagination.totalPages > 1 && index != 0;
      var start = (index * this.pagination.pageSize);
      var end = this.pagination.pageSize + start;
      this.caseList = list.slice((index * this.pagination.pageSize), end);
    },
    filterData() {
      var dt = this.searchQuery.creationDate ? this.searchQuery.creationDate.replaceAll('-', '') : null;
      return this.originalCaseList.filter((item) => {
        if (
          (!this.searchQuery.code || item.caseNumber == this.searchQuery.code) &&
          (!this.searchQuery.typeId || item.caseTypeDesc == this.searchQuery.typeId) &&
          (!this.searchQuery.courtId || item.courtName == this.searchQuery.courtId) &&
          (!this.searchQuery.relationId || item.roleInCaseDesc == this.searchQuery.relationId) &&
          (!this.searchQuery.creationDate || (dt && item.caseDate.indexOf(dt) != -1))
        )
          return item;
      });
    },
    loadFilterData() {
      if (this.originalCaseList && this.originalCaseList.length > 0) {
        this.courts = [...new Set(this.originalCaseList.filter(t => t.courtName)
          .map((i) => {
            return i.courtName;
          }))];
        this.caseTypes = [...new Set(this.originalCaseList.filter(t => t.caseTypeDesc)
          .map((i) => {
            return i.caseTypeDesc;
          }))];

        this.relations = [...new Set(this.originalCaseList.filter(t => t.roleInCaseDesc)
          .map((i) => {
            return i.roleInCaseDesc;
          }))];
      }
    },
    searchCases() {
      this.loadData(0);
    },
    onPageChange(pageIndex) {
      this.pagination.pageIndex = pageIndex - 1;
      this.loadData(pageIndex - 1);
    },
    onSelectionChange(item, index) {
      if (this.selectedCase) {
        this.complaintObj.resetFormModel(true);
        this.complaintObj.complaintForm.formModel.selectedCase = item;
        this.complaintObj.CaseVerificationInfo = { caseNo: item.caseNumber };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-najbox-container {
  ::v-deep {
    .naj-box {
      height: auto;
    }
  }
}
::v-deep {
  .info-item-details:has(.info-item-checkbox) {
    flex-grow: 0;
    max-width: 65px;
  }

  .info-item-details-value span {
    text-wrap: wrap;
  }
}
</style>
